module.exports = __webpack_public_path__ + "img/img2.441dd7bb.png";